import React from 'react';

function useMediaQuery(query) {
	const [matches, setMatches] = React.useState(false);

	React.useEffect(() => {
		const matchQueryList = globalThis.matchMedia(query);

		if (matchQueryList.matches !== matches) setMatches(matchQueryList.matches);

		matchQueryList.addEventListener('change', handleChange);
		return () => {
			matchQueryList.removeEventListener('change', handleChange);
		};

		function handleChange(e) {
			setMatches(e.matches);
		}
	}, [query]);

	return matches;
}

export default useMediaQuery;
